import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

import AdminView from '../views/admin/AdminView.vue'
import ClientView from '../views/client/ClientView.vue'
import LoginView from '@/views/LoginView.vue'

/**
 * 라우트 정의
 *
 * roleGroup:
 * - admin  : 관리자 전용 페이지 (/admin)
 * - client : 일반 사용자 페이지 (/client)
 */
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/admin',
    component: AdminView,
    meta: {
      requiresAuth: true,   // 로그인 필요
      roleGroup: 'admin'    // 관리자만 접근 가능
    }
  },
  {
    path: '/client',
    component: ClientView,
    meta: {
      requiresAuth: true,   // 로그인 필요
      roleGroup: 'client'   // 로그인 사용자면 접근 가능
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

/**
 * 전역 라우터 가드
 *
 * 역할:
 * 1. 로그인 여부 체크
 * 2. 사용자 정보 초기화(fetchMe)
 * 3. 권한에 따른 접근 제어
 */
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  /**
   * 1. 최초 진입 시 사용자 정보 복구
   *
   * - accessToken 있으면 /auth/me 호출해서 user 복구
   * - 실패 시 로그아웃 처리
   */
  if (!authStore.initialized && authStore.accessToken) {
    try {
      await authStore.fetchMe()
    } catch (e) {
      console.warn('fetchMe 실패 → 로그아웃 처리')
      authStore.logout()
    }
  } else {
    authStore.initialized = true
  }

  /**
   * 2. 로그인 필요한 페이지 접근 체크
   *
   * - 로그인 안 된 상태에서 접근 시 /login으로 이동
   */
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
    return
  }

  /**
   * 3. 관리자 페이지 접근 제한
   *
   * - /admin 은 관리자만 접근 가능
   * - USER(일반사용자)는 접근 시 /client 로 리다이렉트
   */
  if (to.meta.roleGroup === 'admin' && !authStore.isAdmin) {
    console.warn('일반사용자 → admin 접근 차단')
    next('/client')
    return
  }

  /**
   * 4. client 페이지 접근
   *
   * - 로그인만 되어 있으면 접근 가능
   * - 별도 role 제한 없음
   */
  if (to.meta.roleGroup === 'client' && !authStore.isAuthenticated) {
    next('/login')
    return
  }

  next()
})

/**
 * 페이지 이동 후 처리
 *
 * - admin / client 에 따라 테마 변경
 */
router.afterEach(to => {
  const isAdminPath = to.path.startsWith('/admin')

  // 예: admin → yellow, client → blue
  document.documentElement.setAttribute(
    'data-theme',
    isAdminPath ? 'yellow' : 'blue'
  )
})

export default router